import { useUserStore } from "../stores/user"
import { useStore } from "vuex";

export default async function auth({ next, to,router }) {

    if (to.meta?.permission) {
        const storeUser = useStore();
        const user = storeUser?.state?.auth?.user?.appUser || {};
        const permissions = useUserStore();
        await permissions.getUser(user);
        // if (!permissions.checkPermissions(to.meta?.permission))return router.push('/auth/access');
        return next();
    }
    return next();
}
